import ApiClient from '../ApiClient';

// The company's own AI meter: what it spent this month, against its quota.
// Read-only — the key and the provider settings live elsewhere.
class TeletelAiUsageAPI extends ApiClient {
  constructor() {
    super('teletel/ai-usage', { accountScoped: true });
  }
}

export default new TeletelAiUsageAPI();
